// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
import { Guid } from "guid-typescript";
export const environment = {
  production: false,
  SPECTRUM_API: 'http://localhost:44306/v1',
  API_KEY : Guid.create()
};
